import React, { useRef } from 'react';
import Receipt from '../Receipt';
import { useReactToPrint } from 'react-to-print';
import { Modal, Button } from 'react-bootstrap';

function ViewReceipt({ order, showReceipt, handleCloseReceipt }) {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  return (
    <Modal
      show={showReceipt}
      size="lg"
      onHide={handleCloseReceipt}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton className="modal-header-dark">
        <Modal.Title className="modal-header-title">View Receipt</Modal.Title>
      </Modal.Header>
      <Receipt ref={componentRef} order={order} />
      <Modal.Footer>
        <Button variant="light" onClick={handleCloseReceipt}>
          Close
        </Button>
        <Button variant="light" onClick={handlePrint}>
          Print
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ViewReceipt;
